/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import { firebase } from '@/firebase/firebaseConfig'
import VuexEasyFirestore from 'vuex-easy-firestore'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)

import moduleCategory from './modules/moduleCategory'

import moduleListing from './modules/moduleListing'
import moduleListingDoc from './modules/moduleListingDoc'
import moduleListingFeature from './modules/moduleListingFeature'
import moduleListingPhoto from './modules/moduleListingPhoto'

import moduleUser from './modules/moduleUser'
import moduleBanner from './modules/moduleBanner'
import moduleTopList from './modules/moduleTopList'
import moduleRecommendationBusiness from './modules/moduleRecommendationBusiness'
import modulePage from './modules/modulePage'
import moduleBusiness from './modules/moduleBusiness'
import moduleBusinessDoc from './modules/moduleBusinessDoc'
import moduleBusinessFeature from './modules/moduleBusinessFeature'
import moduleBusinessPhoto from './modules/moduleBusinessPhoto'

// do the magic 🧙🏻‍♂️
const easyFirestore = VuexEasyFirestore(
  [modulePage, moduleBusiness, moduleBusinessDoc, moduleBusinessFeature, moduleBusinessPhoto, moduleCategory, moduleListing, moduleListingDoc, moduleListingFeature, moduleListingPhoto, moduleUser, moduleBanner, moduleTopList, moduleRecommendationBusiness],
  {logging: true, FirebaseDependency: firebase}
)

import moduleAuth from './auth/moduleAuth.js'

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        auth: moduleAuth,
    },
    // strict: process.env.NODE_ENV !== 'production',
    plugins: [easyFirestore]
})
